import { CustomNode } from '../../../types';
import { holdUntilReplyIcon } from '../../../icons';

export const holdUntilReplyNodeConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: holdUntilReplyIcon,
      defaultTitle: 'Hold until reply',
    };
  },
};
